module.exports = __webpack_public_path__ + "assets/img/26_770.4544d17b.jpg";